import React, { useEffect, useState } from "react";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import { colors } from "../../../../../../../themes/Colors";
import ImageUploadAWS from "../../../../../../user/components/image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const VehicleImage = ({ data }) => {
  const [frontImage, setFrontImage] = useState(null);
  const [leftImage, setLeftImage] = useState(null);
  const [rightImage, setRightImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [saveFrontImage, setSaveFrontImage] = useState(null);
  const [imageError, setImageError] = useState(null);

  const [file, setFile] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [previewUrl, setPreviewFrontUrl] = useState(null);

  const [fileLeft, setFileLeft] = useState(null);

  const [previewUrlLeft, setPreviewFrontUrlLeft] = useState(null);
  const [fileRight, setFileRight] = useState(null);
  const [previewUrlRight, setPreviewFrontUrlRight] = useState(null);
  const [fileBack, setFileBack] = useState(null);
  const [previewUrlBack, setPreviewFrontUrlBack] = useState(null);

  const handleFileChange = (e) => {
    // Uploaded file
    const fileCheck = e.target.files[0];
    // Changing file state
    setFrontImage(fileCheck);
    setFile(fileCheck);
  };

  const handleLeftSideFileChange = (e) => {
    // Uploaded file
    const fileCheck = e.target.files[0];
    // Changing file state
    setLeftImage(fileCheck);
    setFileLeft(fileCheck);
  };

  const handleRightSideFileChange = (e) => {
    // Uploaded file
    const fileCheck = e.target.files[0];
    // Changing file state
    setRightImage(fileCheck);
    setFileRight(fileCheck);
  };

  const handleBackSideFileChange = (e) => {
    // Uploaded file
    const fileCheck = e.target.files[0];
    // Changing file state
    setBackImage(fileCheck);
    setFileBack(fileCheck);
  };

  useEffect(() => {
    if (!file) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewFrontUrl(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);
  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        VEHICLE IMAGES
      </div>
      {/* //front of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Front of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrl} style={{ height: "100%" }} />

          {previewUrl ? null : (
            <ImageUploadAWS
              onChange={(e) => handleFileChange(e)}
              labelTitle={"Upload Vehicle Image ( FRONT )"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      {/* //left of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Left side of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlLeft} style={{ height: "100%" }} />

          {previewUrl ? null : (
            <ImageUploadAWS
              onChange={(e) => handleLeftSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      {/* //right of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Right side of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlRight} style={{ height: "100%" }} />

          {previewUrlRight ? null : (
            <ImageUploadAWS
              onChange={(e) => handleRightSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      {/* //Back of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Back of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlBack} style={{ height: "100%" }} />

          {previewUrlBack ? null : (
            <ImageUploadAWS
              onChange={(e) => handleBackSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>

      {/* //Dashboard of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Dashboard of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlBack} style={{ height: "100%" }} />

          {previewUrlBack ? null : (
            <ImageUploadAWS
              onChange={(e) => handleBackSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      {/* //front interior of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Front interior of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlBack} style={{ height: "100%" }} />

          {previewUrlBack ? null : (
            <ImageUploadAWS
              onChange={(e) => handleBackSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      {/* //Back interior of vehicle */}
      <div
        style={{
          width: "100%",

          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "90%",
            textAlign: "left",
            marginTop: 20,
            fontSize: 16,
            fontWeight: "bold",
          }}
        >
          Back interior of vehicle
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img src={previewUrlBack} style={{ height: "100%" }} />

          {previewUrlBack ? null : (
            <ImageUploadAWS
              onChange={(e) => handleBackSideFileChange(e)}
              labelTitle={"Upload left side Image"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"100%"}
            />
          )}
        </div>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <BaseButtons
            label={"SAVE"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"100%"}
          />
        </div>
      </div>
      <div style={{ minHeight: 60 }} />
      {/* <div
        style={{
          position: "fixed",
          bottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <BaseButtons
          label={"BUTTON"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"90%"}
        />
      </div> */}
    </div>
  );
};

export default VehicleImage;
